var _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChecklist(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 8,
    fill: "#DEE6ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6172 18.8789C21.6172 18.4647 21.953 18.1289 22.3672 18.1289H27.6172C28.0314 18.1289 28.3672 18.4647 28.3672 18.8789C28.3672 19.2931 28.0314 19.6289 27.6172 19.6289H22.3672C21.953 19.6289 21.6172 19.2931 21.6172 18.8789Z",
    fill: "#23262F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9131 16.8486C20.206 17.1415 20.206 17.6163 19.9131 17.9092L17.6631 20.1592C17.3702 20.4521 16.8954 20.4521 16.6025 20.1592L15.8525 19.4092C15.5596 19.1163 15.5596 18.6415 15.8525 18.3486C16.1454 18.0557 16.6202 18.0557 16.9131 18.3486L17.1328 18.5682L18.8525 16.8486C19.1454 16.5557 19.6202 16.5557 19.9131 16.8486Z",
    fill: "#23262F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6172 25.8789C21.6172 25.4647 21.953 25.1289 22.3672 25.1289H27.6172C28.0314 25.1289 28.3672 25.4647 28.3672 25.8789C28.3672 26.2931 28.0314 26.6289 27.6172 26.6289H22.3672C21.953 26.6289 21.6172 26.2931 21.6172 25.8789Z",
    fill: "#23262F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9131 23.8486C20.206 24.1415 20.206 24.6163 19.9131 24.9092L17.6631 27.1592C17.3702 27.4521 16.8954 27.4521 16.6025 27.1592L15.8525 26.4092C15.5596 26.1163 15.5596 25.6415 15.8525 25.3486C16.1454 25.0557 16.6202 25.0557 16.9131 25.3486L17.1328 25.5682L18.8525 23.8486C19.1454 23.5557 19.6202 23.5557 19.9131 23.8486Z",
    fill: "#23262F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0947 13.0947C14.4291 11.7602 16.426 11.25 19 11.25H25C27.574 11.25 29.5709 11.7602 30.9053 13.0947C32.2398 14.4291 32.75 16.426 32.75 19V25C32.75 27.574 32.2398 29.5709 30.9053 30.9053C29.5709 32.2398 27.574 32.75 25 32.75H19C16.426 32.75 14.4291 32.2398 13.0947 30.9053C11.7602 29.5709 11.25 27.574 11.25 25V19C11.25 16.426 11.7602 14.4291 13.0947 13.0947ZM14.1553 14.1553C13.2398 15.0709 12.75 16.574 12.75 19V25C12.75 27.426 13.2398 28.9291 14.1553 29.8447C15.0709 30.7602 16.574 31.25 19 31.25H25C27.426 31.25 28.9291 30.7602 29.8447 29.8447C30.7602 28.9291 31.25 27.426 31.25 25V19C31.25 16.574 30.7602 15.0709 29.8447 14.1553C28.9291 13.2398 27.426 12.75 25 12.75H19C16.574 12.75 15.0709 13.2398 14.1553 14.1553Z",
    fill: "#23262F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklist);
export default __webpack_public_path__ + "static/media/checklist.eda98d1f317ec0af143eede932779be7.svg";
export { ForwardRef as ReactComponent };